/**
 * お気に入り（クライアント要望・2026-08-07）。
 *
 * 保存先はブラウザのlocalStorage。アプリを入れないので月額はかからないが、
 * 端末が変わると引き継がれない。ログインと紐づけたくなったらアプリか
 * 顧客メタフィールドに移す必要がある。
 *
 * 守ること:
 *   - JSが動かない環境ではハートを出さない（押せないボタンを見せない）
 *   - localStorageが使えない環境（プライベートブラウズ等）でも例外で止めない
 *   - 一覧は保存しているのはハンドルだけ。価格と在庫は都度Shopifyから取る
 *     （保存時点の価格を焼き込むと、値上げ後に古い金額が出る）
 */
(function () {
  var KEY = 'sekka_favorites';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* 保存できなくても操作は続けさせる */
    }
    document.dispatchEvent(new CustomEvent('mimi:favchange', { detail: list }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  /** ハートの見た目を今の状態に合わせる。JSが動いた証としてhiddenも外す */
  function paint(btn) {
    var on = has(btn.dataset.skFav);
    btn.hidden = false;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');

    // 商品ページは横に文言が出るので、登録済みかどうかを言葉でも出す
    var label = btn.parentNode && btn.parentNode.querySelector('.sk-pdp__fav-label');
    var T = (window.Sekka && window.Sekka.t) || {};
    if (label) label.textContent = on ? T.fav_added || 'Added to favorites' : T.fav_add || 'Add to favorites';
  }

  function paintAll() {
    document.querySelectorAll('[data-sk-fav]').forEach(paint);
    document.querySelectorAll('[data-sk-fav-count]').forEach(function (el) {
      var n = read().length;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sk-fav]');
    if (!btn) return;
    ev.preventDefault();
    var added = toggle(btn.dataset.skFav);

    // 一覧ページで外したら、その場でカードを消す。
    // 一覧を丸ごと作り直すと全商品を取り直すことになるため
    var card = btn.closest('.sk-card');
    var inList = card && card.parentNode && card.parentNode.hasAttribute('data-sk-fav-list');
    if (!added && inList) {
      card.remove();
      var empty = document.querySelector('[data-sk-fav-empty]');
      if (empty) empty.hidden = read().length > 0;
    }
    paintAll();
  });

  // ---- 一覧ページ ----
  var list = document.querySelector('[data-sk-fav-list]');

  /**
   * カードのHTMLはJSで組み立てない。
   * /products/{handle}?section_id=sekka-fav-card を叩くと、Shopifyが
   * 本物の sekka-product-card スニペットでカード1枚を描いて返す。
   * 以前はここでHTMLを文字列再現していて、Liquid側のカードを変えると
   * JSだけ取り残されて静かにズレる作りだった。カードの正はLiquidの1箇所だけ。
   * 価格・在庫もサーバが描くので、保存時点の値が焼き付く問題も起きない。
   */
  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=sekka-fav-card')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        // セクションのラッパー（shopify-section）は要らないのでカードだけ抜く
        var card = tpl.content.querySelector('.sk-card');
        // 消された商品でもShopifyは404ではなく「空の商品」でセクションを
        // 描いて返してくる（実測）。ハートのhandleが空＝実体が無いカード
        var fav = card && card.querySelector('[data-sk-fav]');
        if (!fav || !fav.dataset.skFav) return null;
        return { handle: handle, el: card };
      })
      .catch(function () { return null; });
  }

  function renderList() {
    if (!list) return;
    var empty = document.querySelector('[data-sk-fav-empty]');
    var handles = read();

    list.innerHTML = '';
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    // 消された商品は404になるので静かに飛ばす
    Promise.all(handles.map(fetchCard)).then(function (items) {
      var alive = items.filter(Boolean);
      alive.forEach(function (it) { list.appendChild(it.el); });

      // 取れなかったぶんは保存から外す（消えた商品を持ち続けない）
      if (alive.length !== handles.length) {
        write(alive.map(function (it) { return it.handle; }));
      }
      if (!alive.length && empty) empty.hidden = false;
      paintAll();
    });
  }

  paintAll();
  renderList();

  /* トップのMOREで商品カードが後から足されたら、そのぶんのハートを塗り直す
     （2026-09-03・sekka-more.js が投げるイベント） */
  document.addEventListener('sekka:products-appended', paintAll);
})();
